//helpers
import { getCookie, setCookie } from 'shared/helpers/utils';

// constants
import { PAGENAME } from 'shared/components/Nudge/constants';
const LOGIN_NUDGE_COOKIE = 'NF_LN';

// both checks to be removed after release 22/06/2023
export const isSessionOver = () => {
  if (
    getCookie(LOGIN_NUDGE_COOKIE) ||
    getCookie(`${PAGENAME.PDP}loginNudge`) ||
    getCookie(`${PAGENAME.PLP}loginNudge`)
  ) {
    return false;
  }
  return true;
};

export const setStorage = (duration: number) => {
  setCookie(LOGIN_NUDGE_COOKIE, true, duration / 24);
};
